import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/global.css'
import './styles/forms.css'
import './styles/components.css'
import './styles/proposal-detail.css'
import './styles/client-proposal.css'
import './styles/markdown.css'
import './styles/knowledge-base.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
